'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RestrictedLengthText = require('./components/RestrictedLengthText.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RestrictedLengthText).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/restricted-length-text/index.js
// module id = 1053
// module chunks = 0